import { render } from "./BaseForm.vue?vue&type=template&id=075fe722"
import script from "./BaseForm.js?vue&type=script&lang=js"
export * from "./BaseForm.js?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__